export class SvgToPngService {
  static convertSVGToPNG(svgElement: any, width: number, height: number) {
    var retVal = new Promise<string | null>((resolve, reject) => {
      if (!svgElement) return null;
      try {
        // Create a Blob from the SVG string
        const svgBlob = new Blob([svgElement], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        // Create an Image element
        const img = new Image();
        img.onload = function () {
          // Create a Canvas element
          const canvas = document.createElement('canvas');
          canvas.width = width || img.width;
          canvas.height = height || img.height;

          // Draw the SVG onto the Canvas
          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Export the Canvas to a PNG
          const base64Image = canvas.toDataURL('image/png').replace('data:image/png;base64,', '');
          URL.revokeObjectURL(url); // Clean up the object URL
          resolve(base64Image); // Return the PNG
        };
        img.src = url; // Load the SVG Blob into the Image
      } catch (e) {
        console.log(e);
        reject(null);
      }
    });
    return retVal;
  }
}
